import { toResult } from "./adapter";
import DataService from "./dataService";

export default class {
  constructor({ dataService } = {}) {
    this.dataService = dataService || new DataService();
  }

  get({ matchId, ...data }) {
    return this.dataService
      .get({ id: matchId, ...data })
      .then((response) => toResult(response))
      .catch((error) => {
        console.error(error);
        throw error;
      });
  }
}
